import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";
import AddCommentIcon from "@mui/icons-material/AddComment";
import CommentIcon from "@mui/icons-material/Comment";

interface Props {
  onClick: () => void;
  isOpen: boolean;

  hasComment: boolean;
}
export const CommentButton = ({ onClick, isOpen, hasComment }: Props) => {
  const { t } = useTranslation();

  let label;
  if (isOpen) {
    label = t("page.wishlist.comment.hide");
  } else if (hasComment) {
    label = t("page.wishlist.comment.show");
  } else {
    label = t("page.wishlist.comment.add");
  }

  const icon = hasComment ? <CommentIcon  /> : <AddCommentIcon  />;

  return (
    <LinkButton data-test-id={"btn-open-comment"} iconBefore={icon} onClick={onClick}>
      {label}
    </LinkButton>
  );
};
